const getCtaIdFromSelect = details => {
  if (details && details.ctaSelect) {
    return parseInt(details.ctaSelect, 10) - 1
  }

  return 0
}

export default getCtaIdFromSelect
